// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.forgot-password-form[data-v-47fe8305] {\n  width: 20%;\n  min-width: 20rem;\n}\n.forgot-password-form .reset-button[data-v-47fe8305] {\n  width: 100%;\n}\n\n", ""]);
// Exports
module.exports = exports;
